import { render, staticRenderFns } from "./PopPupLayout.vue?vue&type=template&id=00a0a5a4"
import script from "./PopPupLayout.vue?vue&type=script&lang=js"
export * from "./PopPupLayout.vue?vue&type=script&lang=js"
import style0 from "./PopPupLayout.vue?vue&type=style&index=0&id=00a0a5a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports